import $ from 'jquery';
import Color from 'color';

import constants from '../constants';
import SimulationLogic from './SimulationLogic';
import Animator from '../visuals/Animator';
import Renderer from '../visuals/Renderer';
import PyramidPointRenderer from '../visuals/point-rendering/PyramidPointRenderer';

const KEYCODE_SPACE = 32;

class CrystalSimulation {
  constructor() {
    this.pointDimensions = null;

    this.logic = null;
    this.renderer = null;
    this.animator = null;
  }

  start() {
    this.pointDimensions = CrystalSimulation._pointDimensionsForWindowDimensions(constants.graphics.POINT_SIZE);
    this.initializeSimulation();

    this.renderer = this._createRenderer(this.pointDimensions, constants.graphics.POINT_SIZE);
    this.animator = this._createAnimator();

    this.renderer.setCanvasDimensions(window.innerWidth, window.innerHeight);
    this.animator.start();

    this._registerListenerForDOMEvents();
  }

  initializeSimulation() {
    this.logic = new SimulationLogic(this.pointDimensions, constants.graphics.CRYSTAL_COLOR);
  }

  onSimulationStep() {
    this.logic.nextStep();
  }

  onAnimationStep() {
    this.renderer.setMatrix(this.logic.pointMatrix.map((row) =>
      row.map((point) => Color(point || constants.graphics.BACKGROUND_COLOR))
    ));
  }

  // =========================================================================
  // Helper methods
  // =========================================================================

  static _pointDimensionsForWindowDimensions(pointSize) {
    return {
      x: Math.ceil(window.innerWidth / pointSize),
      y: Math.ceil(window.innerHeight / pointSize)
    };
  }

  _createRenderer(pointDimensions, pointSize) {
    return new Renderer(
      document.getElementById('mainCanvas'),
      new PyramidPointRenderer(pointSize),
      this.pointDimensions,
      pointSize
    );
  }

  _createAnimator() {
    return new Animator(
      this.onSimulationStep.bind(this),
      this.onAnimationStep.bind(this),
      {
        stepTimeMs: constants.animation.STEP_TIME_MS,
        haltThresholdMs: constants.animation.HALT_THRESHOLD_MS
      }
    );
  }

  _registerListenerForDOMEvents() {
    $(window).on('resize', () => {
      this.renderer.setCanvasDimensions(window.innerWidth, window.innerHeight);
    });

    $(document).on('keydown', (e) => {
      if (e.keyCode === KEYCODE_SPACE) {
        this.animator.stepTimeMs = constants.animation.FF_STEP_TIME_MS;
      }
    });

    $(document).on('keyup', (e) => {
      if (e.keyCode === KEYCODE_SPACE) {
        this.animator.stepTimeMs = constants.animation.STEP_TIME_MS;
      }
    });
  }
}

export default CrystalSimulation;



// WEBPACK FOOTER //
// ./src/simulation/CrystalSimulation.js